/**
 * Created by andrey on 18.01.2021.
 */

const ShadowModel = function () {
    cleverapps.EventEmitter.call(this);
};

ShadowModel.prototype = Object.create(cleverapps.EventEmitter.prototype);
ShadowModel.prototype.constructor = ShadowModel;

ShadowModel.prototype.show = function (delayed) {
    this.trigger("show", delayed);
};

ShadowModel.prototype.hide = function (delayed) {
    this.trigger("hide", delayed);
};

ShadowModel.prototype.moveUp = function () {
    this.trigger("moveUp");
};

ShadowModel.prototype.moveDown = function () {
    this.trigger("moveDown");
};
